import PageHeader from "./PageHeader.vue"

export default {
    install(Vue) {
        Vue.component("PageHeader", PageHeader)
    },
}
